import { faArrowUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";

export default function ButtonUp({ visible, onClick }) {
  return (
    // 1. Naikkan z-index ke [90] (di bawah BottomBar yang z-[99], tapi di atas konten biasa)
    // 2. Tambahkan pointer-events-none agar kotak pembungkusnya tidak memblokir sentuhan
    // 3. Posisikan bottom-24 agar tidak bertabrakan dengan menu bawah
    <div
      className={`fixed z-[90] bottom-24 right-4 md:right-8 pointer-events-none transition-all duration-500 ${
        visible ? "translate-x-0 opacity-100" : "translate-x-20 opacity-0"
      }`}
    >
      {/* 4. pointer-events-auto agar tombolnya bisa diklik */}
      {/* 5. Ubah menjadi bentuk bulat (rounded-full) dengan efek sentuhan (active:scale-95) */}
      <button
        onClick={onClick}
        className="pointer-events-auto flex items-center justify-center w-12 h-12 md:w-14 md:h-14 bg-black/80 hover:bg-black backdrop-blur-md text-white text-lg rounded-full shadow-2xl border border-white/10 transition-all active:scale-90 cursor-pointer"
        aria-label="Kembali ke atas"
      >
        <FontAwesomeIcon icon={faArrowUp} />
      </button>
    </div>
  );
}
